import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "event-item-short__hint-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoubleThumbnail = _resolveComponent("DoubleThumbnail")!
  const _component_NHint = _resolveComponent("NHint")!

  return (_openBlock(), _createBlock(_component_NHint, {
    class: _normalizeClass([_ctx.eventItemContainerClasses, "small-event-item__hint"]),
    placement: "top",
    "delay-hidden": 0,
    "delay-visible": 400
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.date), 1),
        _hoisted_2,
        (_ctx.card?.name)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.card?.name), 1),
              _hoisted_3
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.thumbnail)
        ? (_openBlock(), _createBlock(_component_DoubleThumbnail, {
            key: 0,
            size: "small",
            defaultAction: _ctx.defaultAction,
            "model-value": _ctx.thumbnail,
            "optional-model-value": _ctx.licensePlate,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
          }, null, 8, ["defaultAction", "model-value", "optional-model-value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}